export const LOCALSTORAGE_TOKEN = "MSP_LOCALSTORAGE_TOKEN";
export const LOCALSTORAGE_FAILED_LOGIN = "MSP_LOCALSTORAGE_FAILED_LOGIN";


export function saveToken(token) {
    localStorage.setItem(LOCALSTORAGE_TOKEN, JSON.stringify(token));
}

export function loadToken() {
    return JSON.parse(localStorage.getItem(LOCALSTORAGE_TOKEN))
}

export function isLoggedIn() {
    return localStorage.getItem(LOCALSTORAGE_TOKEN) != null;
}

export function removeToken() {
    localStorage.removeItem(LOCALSTORAGE_TOKEN);
}



// LOCK-LOGIN

export function setLoginFailData(data) {
  localStorage.setItem(LOCALSTORAGE_FAILED_LOGIN, JSON.stringify(data));
}

export function removeLoginFailData() {
  localStorage.removeItem(LOCALSTORAGE_FAILED_LOGIN);
}

export function getLoginFailData() {
  return JSON.parse(localStorage.getItem(LOCALSTORAGE_FAILED_LOGIN));
}
